import { put, select, takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get, isNil } from 'lodash';
import {
  REQUEST_ADD_ELIGIBILITY_TRANSACTION,
  REQUEST_UPDATE_ELIGIBILITY_TRANSACTION,
  REQUEST_ADD_TRANSACTION,
  REQUEST_GET_TRANSACTION,
  REQUEST_UPDATE_TRANSACTION,
  REQUEST_ADD_CONTACT_TRANSACTION,
  REQUEST_GET_CONTACT_TRANSACTION,
  REQUEST_UPDATE_CONTACT_TRANSACTION,
  REQUEST_GET_MISSION_TRANSACTION,
  REQUEST_GET_MISSION_VICTIM_EXPERTISE,
  REQUEST_UPDATE_MISSION_TRANSACTION,
  REQUEST_GET_FEE_NOTES_TRANSACTION,
  REQUEST_IMPORT_MISSION_EXPERTISE,
  REQUEST_GET_JUDICIARY_EXPERT_REPORT,
  REQUEST_MAKE_DECISION_VICTIM_INFO,
  REQUEST_REJECT_TRANSACTION,
  REQUEST_ADD_QUOTATION_DOCUMENT,
  REQUEST_GET_TRANSACTION_INBOXE_AREA,
  REQUEST_ADD_TUTOR_INFO,
  REQUEST_ADD_BENEFICIARY,
} from 'containers/TransactionManagerTimeLine/constants';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import {
  requestSetTransaction,
  requestSetContactTransaction,
  requestGetContactTransaction,
  requestSetMissionTransaction,
  requestSetMissionVictimExpertise,
  requestSetJudiciaryExpertReport,
  requestGetTransaction,
  setTransactionInboxeAreaClaim,
  requestGetMissionTransaction,
} from 'containers/TransactionManagerTimeLine/actions';
import { setFeeNoteByClaimNumber } from 'containers/LawyerFeeNote/actions';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* requestAddEligibilityTransaction(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/eligibility-victim-transaction`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestClaimRecap(get(payload, 'claimId')));
    yield successCallback();
  }
}

export function* makeRequestAddEligibilityTransactionSaga() {
  yield takeLeading(
    REQUEST_ADD_ELIGIBILITY_TRANSACTION,
    requestAddEligibilityTransaction,
  );
}

export function* requestUpdateEligibilityTransaction(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/eligibility-victim-transaction`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestClaimRecap(get(payload, 'claimId')));
    yield successCallback();
  }
}

export function* makeRequestUpdateEligibilityTransactionSaga() {
  yield takeLeading(
    REQUEST_UPDATE_ELIGIBILITY_TRANSACTION,
    requestUpdateEligibilityTransaction,
  );
}

export function* requestAddTransaction(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(get(payload, 'transaction.claimId')));
  }
}
export function* makeRequestAddTransactionSaga() {
  yield takeLeading(REQUEST_ADD_TRANSACTION, requestAddTransaction);
}

export function* requestGetTransactions(action: any): Generator<unknown> {
  const {
    payload: { claimId, isIntervenant },
  } = action;

  const token = !isIntervenant
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  if (isNil(token)) return;
  const path = !isIntervenant
    ? `/corporeal/transaction?claimId=${claimId}`
    : `/corporeal/transaction/victims?claimId=${claimId}`;

  yield callApi(path, {}, options, [], requestSetTransaction);
}

export function* makeRequestGetTransactionSaga() {
  yield takeLeading(REQUEST_GET_TRANSACTION, requestGetTransactions);
}

export function* requestUpdateTransaction(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(get(payload, 'claimId')));
  }
}
export function* makeRequestUpdateTransactionSaga() {
  yield takeLeading(REQUEST_UPDATE_TRANSACTION, requestUpdateTransaction);
}

export function* requestGetContactTransactionSaga(
  action: any,
): Generator<unknown> {
  const {
    payload: { transactionId, isIntervenant },
  } = action;

  const token = !isIntervenant
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = !isIntervenant
    ? `/corporeal/transaction-contact?transactionId=${transactionId}`
    : `/corporeal/transaction-contact?transactionId=${transactionId}&isIntervenant=true`;

  yield callApi(path, {}, options, [], requestSetContactTransaction);
}

export function* makeRequestGetContactTransactionSaga() {
  yield takeLeading(
    REQUEST_GET_CONTACT_TRANSACTION,
    requestGetContactTransactionSaga,
  );
}
export function* requestAddContactTransaction(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction-contact`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetContactTransaction({
        transactionId: get(payload, 'transactionContact.transactionId'),
      }),
    );
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'transactionContact.claimId'),
      }),
    );
    yield put(
      requestGetExpertiseVictim({
        missionId: null,
        claimId: get(payload, 'transactionContact.claimId'),
        missionVictimId: null,
        missionVehicleId: null,
        isIntervenant: false,
      }),
    );
    yield put(requestClaimRecap(get(payload, 'transactionContact.claimId')));
  }
}

export function* makeRequestAddContactTransactionSaga() {
  yield takeLeading(
    REQUEST_ADD_CONTACT_TRANSACTION,
    requestAddContactTransaction,
  );
}
export function* requestUpdateContactTransaction(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction-contact`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetContactTransaction({
        transactionId: get(payload, 'transactionId'),
      }),
    );
    yield put(requestClaimRecap(get(payload, 'claimId')));
  }
}
export function* makeRequestUpateContactTransactionSaga() {
  yield takeLeading(
    REQUEST_UPDATE_CONTACT_TRANSACTION,
    requestUpdateContactTransaction,
  );
}

export function* requestGetMissionTransactionSaga(
  action: any,
): Generator<unknown> {
  const {
    payload: { transactionId, isIntervenant },
  } = action;

  const token = !isIntervenant
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = !isIntervenant
    ? `/corporeal/mission/transaction/${transactionId}`
    : `/corporeal/mission/transaction/${transactionId}?isIntervenant=true`;

  yield callApi(path, {}, options, [], requestSetMissionTransaction);
}

export function* makeRequestGetMissionTransactionSaga() {
  yield takeLeading(
    REQUEST_GET_MISSION_TRANSACTION,
    requestGetMissionTransactionSaga,
  );
}

export function* requestGetMissionVictimExpertiseSaga(
  action: any,
): Generator<unknown> {
  const {
    payload: { transactionId, isIntervenant },
  } = action;

  const token = !isIntervenant
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const path = !isIntervenant
    ? `/corporeal/mission-expertise-victim/transaction?transactionId=${transactionId}`
    : `/corporeal/mission-expertise-victim/transaction?transactionId=${transactionId}&isIntervenant=${isIntervenant}`;

  yield callApi(path, {}, options, [], requestSetMissionVictimExpertise);
}

export function* makeRequestGetMissionVictimExpertiseSaga() {
  yield takeLeading(
    REQUEST_GET_MISSION_VICTIM_EXPERTISE,
    requestGetMissionVictimExpertiseSaga,
  );
}

export function* makeRequestUpdateMission(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/mission/change-mission`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
    yield put(
      requestGetMissionTransaction({
        transactionId: get(payload, 'transactionId'),
        isIntervenant: false,
      }),
    );
    yield put(
      requestGetContactTransaction({
        transactionId: get(payload, 'transactionId'),
        isIntervenant: false,
      }),
    );
  }
}

export function* makeRequestUpdateMissionSaga() {
  yield takeLeading(
    REQUEST_UPDATE_MISSION_TRANSACTION,
    makeRequestUpdateMission,
  );
}

export function* makeRequestGetFeeNoteTransaction(
  action: any,
): Generator<unknown> {
  const {
    payload: { transactionId },
  } = action;

  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/fee-note/transaction-manager?transactionId=${transactionId}`;

  yield callApi(path, {}, options, [], setFeeNoteByClaimNumber);
}

export function* makeRequestGetFeeNotesTransactionSaga() {
  yield takeLeading(
    REQUEST_GET_FEE_NOTES_TRANSACTION,
    makeRequestGetFeeNoteTransaction,
  );
}

export function* requestImportMissionExpertise(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/mission/import`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
  }
}

export function* makeRequestImportMissionExpertiseSaga() {
  yield takeLeading(
    REQUEST_IMPORT_MISSION_EXPERTISE,
    requestImportMissionExpertise,
  );
}
export function* requestGetJudiciaryExpertReport(
  action: any,
): Generator<unknown> {
  const {
    payload: { claimId, victimId },
  } = action;

  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/judgement/export-reports-by-victim-id/${claimId}/${victimId}`;

  yield callApi(path, {}, options, [], requestSetJudiciaryExpertReport);
}
export function* makeRequestGetJudiciaryExpertReportSaga() {
  yield takeLeading(
    REQUEST_GET_JUDICIARY_EXPERT_REPORT,
    requestGetJudiciaryExpertReport,
  );
}
export function* requestMakeDecisionVictimInfo(
  action: any,
): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction/make-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
  }
}
export function* makeRequestMakeDecisionVictimInfoSaga() {
  yield takeLeading(
    REQUEST_MAKE_DECISION_VICTIM_INFO,
    requestMakeDecisionVictimInfo,
  );
}
export function* requestRejectTransaction(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction/reject`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
  }
}
export function* makeRequestRejectTransactionSaga() {
  yield takeLeading(REQUEST_REJECT_TRANSACTION, requestRejectTransaction);
}
export function* requestAddQuotationDocument(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/transaction-quotation-document`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
  }
}

export function* makeRequestAddQuotationDocumentSaga() {
  yield takeLeading(
    REQUEST_ADD_QUOTATION_DOCUMENT,
    requestAddQuotationDocument,
  );
}
export function* requestGetTransactionInboxeArea(
  action: any,
): Generator<unknown> {
  const { claimId } = action;

  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/notification-manager-transaction/transaction-area-inboxe-id/${claimId}`;

  yield callApi(path, {}, options, [], setTransactionInboxeAreaClaim);
}
export function* makeRequestGetTransactionInboxeAreaSaga() {
  yield takeLeading(
    REQUEST_GET_TRANSACTION_INBOXE_AREA,
    requestGetTransactionInboxeArea,
  );
}
export function* requestAddTutorInfo(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;

  const token = accessTokenStorage.get().token;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const path = `/corporeal/tutor`;

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'claimId'),
      }),
    );
  }
}
export function* makeRequestAddTutorInfoSaga() {
  yield takeLeading(REQUEST_ADD_TUTOR_INFO, requestAddTutorInfo);
}
export function* requestAddBeneficiary(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;

  const token = accessTokenStorage.get().token;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const path = `/corporeal/beneficiary`;

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetTransaction({
        claimId: get(payload, 'beneficiary.claimId'),
      }),
    );
  }
}
export function* makeRequestAddBeneficiarySaga() {
  yield takeLeading(REQUEST_ADD_BENEFICIARY, requestAddBeneficiary);
}
export default [
  makeRequestAddTransactionSaga,
  makeRequestAddEligibilityTransactionSaga,
  makeRequestGetTransactionSaga,
  makeRequestUpdateTransactionSaga,
  makeRequestUpdateEligibilityTransactionSaga,
  makeRequestAddContactTransactionSaga,
  makeRequestGetContactTransactionSaga,
  makeRequestUpateContactTransactionSaga,
  makeRequestGetMissionTransactionSaga,
  makeRequestGetMissionVictimExpertiseSaga,
  makeRequestUpdateMissionSaga,
  makeRequestGetFeeNotesTransactionSaga,
  makeRequestImportMissionExpertiseSaga,
  makeRequestGetJudiciaryExpertReportSaga,
  makeRequestMakeDecisionVictimInfoSaga,
  makeRequestRejectTransactionSaga,
  makeRequestAddQuotationDocumentSaga,
  makeRequestGetTransactionInboxeAreaSaga,
  makeRequestAddTutorInfoSaga,
  makeRequestAddBeneficiarySaga,
];
